import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientAllocationActions, IThunkGetClientAllocation } from '../types';

const onGetClientAllocation: IThunkGetClientAllocation = thunk(
  async ({ setClientAllocation }: Actions<IClientAllocationActions>, payload) => {
    const clientAllocations = await api.clientAllocation
      .getClientAllocation(payload)
      .then(r => r.data);

    setClientAllocation(clientAllocations);

    return clientAllocations;
  },
);

export default onGetClientAllocation;
